import { isDefined } from '@/composables/utils'
import type { ITableHeader } from '@/interfaces/ITableHeader'
import { type Composer } from 'vue-i18n'
import type { MedicalClearanceRecord } from '../MedicalClearanceRecord'

export const getTableHeaders = (
  i18n: Composer<{}, {}, {}, string, never, string>
): Array<ITableHeader> => {
  return [
    {
      title: i18n.t('fields.clearance.clearanceDate'),
      key: 'clearanceDate',
      nowrap: true,
      align: 'start',
      value: (item: MedicalClearanceRecord) => {
        return isDefined(item.clearanceDate) ? item.clearanceDate : null
      }
    },
    {
      title: i18n.t('fields.clearance.expiration'),
      key: 'expiration',
      align: 'start',
      nowrap: true,
      value: (item: MedicalClearanceRecord) => {
        return isDefined(item.expiration) ? item.expiration : null
      }
    },
    {
      title: i18n.t('fields.clearance.restrictions'),
      key: 'restrictions',
      align: 'start',
      nowrap: true,
      headerProps: { searchField: true }
    },
    {
      title: i18n.t('fields.clearance.disposable'),
      key: 'disposable',
      nowrap: true,
      align: 'start',
      value: (item: MedicalClearanceRecord) =>
        `${item.disposable ? i18n.t('labels.yes') : i18n.t('labels.no')}`
    },
    {
      title: i18n.t('fields.clearance.scba'),
      key: 'scba',
      nowrap: true,

      align: 'start',
      value: (item: MedicalClearanceRecord) =>
        `${item.scba ? i18n.t('labels.yes') : i18n.t('labels.no')}`
    },
    {
      title: i18n.t('fields.clearance.hfSAR'),
      key: 'hfSAR',
      nowrap: true,

      align: 'start',
      value: (item: MedicalClearanceRecord) =>
        `${item.hfSAR ? i18n.t('labels.yes') : i18n.t('labels.no')}`
    },
    {
      title: i18n.t('fields.clearance.ffSAR'),
      key: 'ffSAR',
      nowrap: true,

      align: 'start',
      value: (item: MedicalClearanceRecord) =>
        `${item.ffSAR ? i18n.t('labels.yes') : i18n.t('labels.no')}`
    },
    {
      title: i18n.t('fields.clearance.hfPAPR'),
      key: 'hfPAPR',
      nowrap: true,

      align: 'start',
      value: (item: MedicalClearanceRecord) =>
        `${item.hfPAPR ? i18n.t('labels.yes') : i18n.t('labels.no')}`
    },
    {
      title: i18n.t('fields.clearance.hfNPR'),
      key: 'hfNPR',
      align: 'start',
      value: (item: MedicalClearanceRecord) =>
        `${item.hfNPR ? i18n.t('labels.yes') : i18n.t('labels.no')}`
    },
    {
      title: i18n.t('fields.clearance.ffPAPR'),
      key: 'ffPAPR',
      nowrap: true,
      align: 'start',
      value: (item: MedicalClearanceRecord) =>
        `${item.ffPAPR ? i18n.t('labels.yes') : i18n.t('labels.no')}`
    },
    {
      title: i18n.t('fields.clearance.ffNPR'),
      key: 'ffNPR',
      nowrap: true,
      align: 'start',
      value: (item: MedicalClearanceRecord) =>
        `${item.ffNPR ? i18n.t('labels.yes') : i18n.t('labels.no')}`
    }
  ]
}
